import {
  getInitialFlightList,
  INITIALIZE_APP,
  periodicConfigurationFetch,
  startPeriodicDataFetch,
  stopPeriodicConfigurationFetch,
  stopPeriodicDataFetch,
  UNINITIALIZE_APP,
  updateActiveAircraft,
  updateActiveFlight,
  updateAircraftMap,
  updateConfiguration,
  updateCurrentTime,
  updateFlightMap,
  getUser,
} from 'actions';
import { subtractTimeFromNow } from 'utils';
import { fiveMinInterval } from 'constants';
import config from 'config';
import store from 'store';

export const initializeApp = (user) => {
  const { initialized, aircraftList } = store.getState();

  if (!initialized) {
    return async (dispatch) => {
      await dispatch(updateConfiguration());
      const { configuration } = store.getState();
      let fetchData = !configuration.maintenance_mode;

      // Calculate all the dates
      const fiveMinAgo = subtractTimeFromNow(5, 'minutes');
      const dt1DayAgo = subtractTimeFromNow(1, 'day');
      const dt7DaysAgo = subtractTimeFromNow(7, 'days');

      let fetchTime = dt7DaysAgo;

      if (invalidateApplicationData(configuration)) {
        localStorage.setItem('invalidationDatetime', Date.now());
        localStorage.removeItem('state');
        fetchData = true;
      } else if (aircraftList) {
        // Get the latest modified date from aircraft list
        const latestmodifiedDt = Math.max(
          ...aircraftList.map((aircraft) => aircraft.modified),
        );

        // If latest modified date is older than 5 mins than fetch the data
        fetchData = fetchData && latestmodifiedDt < fiveMinAgo;

        // If latest modified date is older than a day than fetch everything
        // Else Fetch data for last 24 hrs.
        fetchTime =
          fetchData && latestmodifiedDt > dt1DayAgo ? dt1DayAgo : dt7DaysAgo;
      }

      const promises = [];
      const initailFlightAPIPageSize = 1000;

      promises.push(dispatch(getUser(user)));
      promises.push(dispatch(updateCurrentTime()));
      if (fetchData) {
        promises.push(dispatch(updateAircraftMap()));
        promises.push(dispatch(updateActiveAircraft()));
      }
      await Promise.all(promises);

      // Get all the current flights if fetchTime is 7 days ago.
      if (fetchData) {
        const { aircraftMap: aircrafts } = store.getState();
        let currentFlightIds = [];
        aircrafts?.forEach((aircraft) => {
          const id = aircraft.flights?.at(0)?.id;
          if (id) currentFlightIds.push(id);
        });
        await dispatch(getInitialFlightList(currentFlightIds, fetchTime));
      }

      dispatch({
        type: INITIALIZE_APP,
      });

      if (fetchData) {
        // Lazy load of all the flights once UI is loaded
        dispatch(updateFlightMap(fetchTime, initailFlightAPIPageSize));
        dispatch(updateActiveFlight());
      }

      setTimeout(() => dispatch(periodicConfigurationFetch()), fiveMinInterval);
      setTimeout(
        () => dispatch(startPeriodicDataFetch()),
        config.app.refreshInterval,
      );
    };
  } else {
    return async () => {};
  }
};

export const unititializeApp = () => {
  return async (dispatch) => {
    dispatch({
      type: UNINITIALIZE_APP,
    });

    dispatch(stopPeriodicConfigurationFetch());
    dispatch(stopPeriodicDataFetch());
  };
};

// invalidate stale application data
const invalidateApplicationData = (configuration) => {
  const { application_data_invalidation_datetime: globalInvalidationDatetime } =
    configuration;

  const localInvalidationDatetime = localStorage.getItem(
    'invalidationDatetime',
  );

  if (
    !localInvalidationDatetime ||
    parseInt(globalInvalidationDatetime, 10) > localInvalidationDatetime
  ) {
    return true;
  }

  return false;
};
